import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articleCards } from "@/mocks/seo-data";

export default function ArticlePreview() {
  const { t } = useTranslation("common");

  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block border border-foreground-300 rounded-full px-5 py-2 mb-6">
            <span className="text-sm text-foreground-600 font-medium">(Artykuły SEO)</span>
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
            Poradniki i artykuły{" "}
            <span className="text-primary-500">USFansSpreadsheet</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Poznaj nasze szczegółowe artykuły na temat USFansSpreadsheet. Poradniki, recenzje, analizy bezpieczeństwa i wiele więcej.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article, i) => (
            <Link
              key={i}
              to={`/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full">
                  {article.subtitle}
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                  {t("readArticle")}
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}